import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { ciandtspikeDeleteEntityTranslationRef } from '../translation';

export const availableLanguages = ['en', 'pt-BR'] as const;

export async function loadPtBrTranslations() {
  const ptBrModule = await import('./pt-BR.json');
  return {
    default: createTranslationMessages({
      ref: ciandtspikeDeleteEntityTranslationRef,
      full: false,
      messages: ptBrModule.default,
    }),
  };
}

export const ciandtspikeDeleteEntityTranslations = createTranslationResource({
  ref: ciandtspikeDeleteEntityTranslationRef,
  translations: {
    'pt-BR': loadPtBrTranslations,
  },
});
